import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import withRouter from "components/Common/withRouter"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"
import PageTitle from "../../components/Common/PageTitle"

import avatar from "../../assets/images/users/avatar-1.jpg"
// actions
import { editProfile, resetProfileFlag } from "../../store/actions"
import UserService from "Api/Services/UserService"
import Spinners from "components/Common/Spinner"
import Nouserimage from "../../assets/images/users/no_image.png"

const UserProfile = () => {
  //meta title
  document.title = "Profile | Infuse One"
  const [name, setName] = useState()
  const [getPracticeName, setPracticename] = useState()
  const [username, setUserName] = useState()
  const [email, setEmail] = useState()
  const [phoneNumber, setPhoneNumber] = useState()
  const [profileImage, setProfileImage] = useState()
  const [previewImage, setPreviewImage] = useState(null)
  const [getSpecialty, setSpecialty] = useState("")
  const [getQualification, setQualification] = useState("")
  const [error, setError] = useState("")
  const [success, setSuccess] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [errorimage, setErrorimage] = useState(false)
  const [getFaxNumber, setFaxNumber] = useState("")
  // State for new fields
  const [practiceContactFirstName, setPracticeContactFirstName] = useState("")
  const [practiceContactLastName, setPracticeContactLastName] = useState("")
  const [practiceEmail, setPracticeEmail] = useState("")
  const [practicePhoneNumber, setPracticePhoneNumber] = useState("")
  const [practiceAddress, setPracticeAddress] = useState({
    address_line_1: "",
    address_line_2: "",
    city: "",
    state: "",
    zip: "",
  })
  useEffect(() => {
    getUser()
  }, [])

  const getUser = async () => {
    setLoading(true)
    try {
      let response = await UserService.GetUser()
      setName(response.data.name)
      setPracticename(response.data.practicename)
      setUserName(response.data.username)
      setEmail(response.data.email)
      setPhoneNumber(response.data.phone_number)
      setSpecialty(response.data.specialty)
      setQualification(response.data.qualification)
      setFaxNumber(response.data.faxnumber)
      // New fields
      setPracticeContactFirstName(
        response.data.practice_contact_first_name || ""
      )
      setPracticeContactLastName(response.data.practice_contact_last_name || "")
      setPracticeEmail(response.data.practice_email || "")
      setPracticePhoneNumber(response.data.practice_phone_number || "")
      setPracticeAddress(response.data.practice_address || {})
      // const imageUrl = `${process.env.REACT_APP_PROFILE_IMAGE_API_URL}/${response.data.profile_image}`;
      const imageUrl = response.data.profile_image
        ? `${process.env.REACT_APP_PROFILE_IMAGE_API_URL}/${response.data.profile_image}`
        : null
      setProfileImage(imageUrl)
      setLoading(false)
      if (response.status == false) {
        setError(response.message)
        return
      }
    } catch (error) {
      setError("something went wrong")
      return
    }
  }

  const handleImageChange = event => {
    const file = event.target.files[0]

    if (file) {
      const fileType = file.type
      const validImageTypes = ["image/jpeg", "image/png", "image/gif"]

      if (validImageTypes.includes(fileType)) {
        const reader = new FileReader()
        reader.onloadend = () => {
          setPreviewImage(reader.result)
        }
        reader.readAsDataURL(file)
      } else {
        setErrorimage("Please upload a valid image.")
        return
        // alert('Please upload a valid image file.');
      }
    }
  }

  // Handle form submission
  const handleSubmit = async e => {
    e.preventDefault()

    const userData = {
      username: e.target.username.value,
      name: name,
      practicename: getPracticeName,
      phone_number: phoneNumber,
      email: email,
      profile_image: previewImage,
      specialty: getSpecialty,
      qualification: getQualification,
      faxnumber: getFaxNumber,
      practice_contact_first_name: practiceContactFirstName,
      practice_contact_last_name: practiceContactLastName,
      practice_email: practiceEmail,
      practice_phone_number: practicePhoneNumber,
      address_line_1: practiceAddress.address_line_1,
      address_line_2: practiceAddress.address_line_2,
      city: practiceAddress.city,
      state: practiceAddress.state,
      zip_code: practiceAddress.zip_code,
      country: practiceAddress.country,
    }
    // setLoading(true);
    try {
      const response = await UserService.profileupdate(userData).json()
      if (response.status === true) {
        setError("")
        setSuccess(response.message)
        // setLoading(false);
        setErrorimage("")
        getUser()
      } else {
        // setLoading(false);
        setError(response.errors)
        return
      }
    } catch (error) {
      setError("something went wrong")
      return
    }
  }

  const handleNameChange = e => {
    const regex = /^[A-Za-z\s]*$/
    const newValue = e.target.value
    if (regex.test(newValue)) {
      setName(newValue)
    }
  }
  const handlePracticeNameChange = e => {
    const regex = /^[A-Za-z\s]*$/
    const newValue = e.target.value
    if (regex.test(newValue)) {
      setPracticename(newValue)
    }
  }

  const handlePhoneNumberChange = e => {
    const newValue = e.target.value
    if (/^\d{0,12}$/.test(newValue)) {
      setPhoneNumber(newValue)
    }
  }

  const handleSpecialtyChange = e => {
    const regex = /^[A-Za-z\s]*$/
    const newValue = e.target.value
    if (regex.test(newValue)) {
      setSpecialty(newValue)
    }
  }

  const handleQualificationChange = e => {
    const regex = /^\d[0,10]$/ // Only digits allowed
    const newValue = e.target.value
    if (regex.test(newValue)) {
      setQualification(newValue)
    }
  }
  const handleFaxnumberonChange = e => {
    const regex = /^[0-9\s!@#$%^&*()_\-+=\[\]{}|\\;:,.<>/?`~]*$/
    const newValue = e.target.value
    if (regex.test(newValue)) {
      setFaxNumber(newValue)
    }
  }

  // Add handlers for validation if needed
  const handlePracticeContactFirstNameChange = e => {
    const regex = /^[A-Za-z\s]*$/
    const newValue = e.target.value
    if (regex.test(newValue)) setPracticeContactFirstName(newValue)
  }

  const handlePracticeContactLastNameChange = e => {
    const regex = /^[A-Za-z\s]*$/
    const newValue = e.target.value
    if (regex.test(newValue)) setPracticeContactLastName(newValue)
  }

  const handlePracticeEmailChange = e => setPracticeEmail(e.target.value)

  const handlePracticePhoneNumberChange = e => {
    const newValue = e.target.value
    if (/^\d{0,12}$/.test(newValue)) setPracticePhoneNumber(newValue)
  }

  // const handlePracticeAddressChange = e => setPracticeAddress(e.target.value)

  // stateList.json (static 5 records)
  const stateList = [
    { id: 1, name: "Alabama" },
    { id: 2, name: "Alaska" },
    { id: 3, name: "Arizona" },
    { id: 4, name: "Arkansas" },
    { id: 5, name: "California" },
    { id: 6, name: "Colorado" },
    { id: 7, name: "Connecticut" },
    { id: 8, name: "Delaware" },
    { id: 9, name: "District of Columbia" },
    { id: 10, name: "Florida" },
    { id: 11, name: "Georgia" },
    { id: 12, name: "Guam" },
    { id: 13, name: "Hawaii" },
    { id: 14, name: "Idaho" },
    { id: 15, name: "Illinois" },
    { id: 16, name: "Indiana" },
    { id: 17, name: "Iowa" },
    { id: 18, name: "Kansas" },
    { id: 19, name: "Kentucky" },
    { id: 20, name: "Louisiana" },
    { id: 21, name: "Maine" },
    { id: 22, name: "Maryland" },
    { id: 23, name: "Massachusetts" },
    { id: 24, name: "Michigan" },
    { id: 25, name: "Minnesota" },
    { id: 26, name: "Mississippi" },
    { id: 27, name: "Missouri" },
    { id: 28, name: "Montana" },
    { id: 29, name: "Nebraska" },
    { id: 30, name: "Nevada" },
    { id: 31, name: "New Hampshire" },
    { id: 32, name: "New Jersey" },
    { id: 33, name: "New Mexico" },
    { id: 34, name: "New York" },
    { id: 35, name: "North Carolina" },
    { id: 36, name: "North Dakota" },
    { id: 37, name: "Ohio" },
    { id: 38, name: "Oklahoma" },
    { id: 39, name: "Oregon" },
    { id: 40, name: "Pennsylvania" },
    { id: 41, name: "Puerto Rico" },
    { id: 42, name: "Rhode Island" },
    { id: 43, name: "South Carolina" },
    { id: 44, name: "South Dakota" },
    { id: 45, name: "Tennessee" },
    { id: 46, name: "Texas" },
    { id: 47, name: "Utah" },
    { id: 48, name: "Vermont" },
    { id: 49, name: "Virgin Islands (US)" },
    { id: 50, name: "Virginia" },
    { id: 51, name: "Washington" },
    { id: 52, name: "West Virginia" },
    { id: 53, name: "Wisconsin" },
    { id: 54, name: "Wyoming" },

    // Military / Armed Forces
    { id: 55, name: "Armed Forces (the) Americas" },
    { id: 56, name: "Armed Forces Europe" },
    { id: 57, name: "Armed Forces Pacific" },
    { id: 58, name: "Army Post Office (U.S. Army and U.S. Air Force)" },
    { id: 59, name: "Fleet Post Office (U.S. Navy and U.S. Marine Corps)" },
  ]

  // countryList.json (static 5 records)
  const countryList = [
    { id: 1, name: "Afghanistan" },
    { id: 2, name: "Aland Islands" },
    { id: 3, name: "Albania" },
    { id: 4, name: "Algeria" },
    { id: 5, name: "American Samoa" },
    { id: 6, name: "Andorra" },
    { id: 7, name: "Angola" },
    { id: 8, name: "Anguilla" },
    { id: 9, name: "Antarctica" },
    { id: 10, name: "Antigua And Barbuda" },
    { id: 11, name: "Argentina" },
    { id: 12, name: "Armenia" },
    { id: 13, name: "Aruba" },
    { id: 14, name: "Australia" },
    { id: 15, name: "Austria" },
    { id: 16, name: "Azerbaijan" },
    { id: 17, name: "Bahamas" },
    { id: 18, name: "Bahrain" },
    { id: 19, name: "Bangladesh" },
    { id: 20, name: "Barbados" },
    { id: 21, name: "Belarus" },
    { id: 22, name: "Belgium" },
    { id: 23, name: "Belize" },
    { id: 24, name: "Benin" },
    { id: 25, name: "Bermuda" },
    { id: 26, name: "Bhutan" },
    { id: 27, name: "Bolivia" },
    { id: 28, name: "Bonaire, Sint Eustatius And Saba" },
    { id: 29, name: "Bosnia And Herzegovina" },
    { id: 30, name: "Botswana" },
    { id: 31, name: "Bouvet Island" },
    { id: 32, name: "Brazil" },
    { id: 33, name: "British Indian Ocean Territory" },
    { id: 34, name: "Brunei Darussalam" },
    { id: 35, name: "Bulgaria" },
    { id: 36, name: "Burkina Faso" },
    { id: 37, name: "Burundi" },
    { id: 38, name: "Cambodia" },
    { id: 39, name: "Cameroon" },
    { id: 40, name: "Canada" },
    { id: 41, name: "Cape Verde" },
    { id: 42, name: "Cayman Islands" },
    { id: 43, name: "Central African Republic" },
    { id: 44, name: "Chad" },
    { id: 45, name: "Chile" },
    { id: 46, name: "China" },
    { id: 47, name: "Christmas Island" },
    { id: 48, name: "Cocos (Keeling) Islands" },
    { id: 49, name: "Colombia" },
    { id: 50, name: "Comoros" },
    { id: 51, name: "Congo" },
    { id: 52, name: "The Democratic Republic Of The Congo" },
    { id: 53, name: "Cook Islands" },
    { id: 54, name: "Costa Rica" },
    { id: 55, name: "Cote d'Ivoire" },
    { id: 56, name: "Croatia" },
    { id: 57, name: "Cuba" },
    { id: 58, name: "Curacao" },
    { id: 59, name: "Cyprus" },
    { id: 60, name: "Czech Republic" },
    { id: 61, name: "Denmark" },
    { id: 62, name: "Djibouti" },
    { id: 63, name: "Dominica" },
    { id: 64, name: "Dominican Republic" },
    { id: 65, name: "Ecuador" },
    { id: 66, name: "Egypt" },
    { id: 67, name: "El Salvador" },
    { id: 68, name: "Equatorial Guinea" },
    { id: 69, name: "Eritrea" },
    { id: 70, name: "Estonia" },
    { id: 71, name: "Ethiopia" },
    { id: 72, name: "Falkland Islands (Malvinas)" },
    { id: 73, name: "Faroe Islands" },
    { id: 74, name: "Fiji" },
    { id: 75, name: "Finland" },
    { id: 76, name: "France" },
    { id: 77, name: "French Guiana" },
    { id: 78, name: "French Polynesia" },
    { id: 79, name: "French Southern Territories" },
    { id: 80, name: "Gabon" },
    { id: 81, name: "Gambia" },
    { id: 82, name: "Georgia" },
    { id: 83, name: "Germany" },
    { id: 84, name: "Ghana" },
    { id: 85, name: "Gibraltar" },
    { id: 86, name: "Greece" },
    { id: 87, name: "Greenland" },
    { id: 88, name: "Grenada" },
    { id: 89, name: "Guadeloupe" },
    { id: 90, name: "Guam" },
    { id: 91, name: "Guatemala" },
    { id: 92, name: "Guernsey" },
    { id: 93, name: "Guinea" },
    { id: 94, name: "Guinea-Bissau" },
    { id: 95, name: "Guyana" },
    { id: 96, name: "Haiti" },
    { id: 97, name: "Heard Island And Mcdonald Islands" },
    { id: 98, name: "Honduras" },
    { id: 99, name: "Hong Kong" },
    { id: 100, name: "Hungary" },
    { id: 101, name: "Iceland" },
    { id: 102, name: "India" },
    { id: 103, name: "Indonesia" },
    { id: 104, name: "Iran, Islamic Republic of" },
    { id: 105, name: "Iraq" },
    { id: 106, name: "Ireland" },
    { id: 107, name: "Isle Of Man" },
    { id: 108, name: "Israel" },
    { id: 109, name: "Italy" },
    { id: 110, name: "Jamaica" },
    { id: 111, name: "Japan" },
    { id: 112, name: "Jersey" },
    { id: 113, name: "Jordan" },
    { id: 114, name: "Kazakhstan" },
    { id: 115, name: "Kenya" },
    { id: 116, name: "Kiribati" },
    { id: 117, name: "Republic Of Korea" },
    { id: 118, name: "Kosovo" },
    { id: 119, name: "Kuwait" },
    { id: 120, name: "Kyrgyzstan" },
    { id: 121, name: "Lao People's Democratic Republic" },
    { id: 122, name: "Latvia" },
    { id: 123, name: "Lebanon" },
    { id: 124, name: "Lesotho" },
    { id: 125, name: "Liberia" },
    { id: 126, name: "Libya" },
    { id: 127, name: "Liechtenstein" },
    { id: 128, name: "Lithuania" },
    { id: 129, name: "Luxembourg" },
    { id: 130, name: "Macao" },
    { id: 131, name: "The Former Yugoslav Republic Of Macedonia" },
    { id: 132, name: "Madagascar" },
    { id: 133, name: "Malawi" },
    { id: 134, name: "Malaysia" },
    { id: 135, name: "Maldives" },
    { id: 136, name: "Mali" },
    { id: 137, name: "Malta" },
    { id: 138, name: "Marshall Islands" },
    { id: 139, name: "Martinique" },
    { id: 140, name: "Mauritania" },
    { id: 141, name: "Mauritius" },
    { id: 142, name: "Mayotte" },
    { id: 143, name: "Mexico" },
    { id: 144, name: "Federated States Of Micronesia" },
    { id: 145, name: "Republic Of Moldova" },
    { id: 146, name: "Monaco" },
    { id: 147, name: "Mongolia" },
    { id: 148, name: "Montenegro" },
    { id: 149, name: "Montserrat" },
    { id: 150, name: "Morocco" },
    { id: 151, name: "Mozambique" },
    { id: 152, name: "Myanmar" },
    { id: 153, name: "Namibia" },
    { id: 154, name: "Nauru" },
    { id: 155, name: "Nepal" },
    { id: 156, name: "Netherlands" },
    { id: 157, name: "New Caledonia" },
    { id: 158, name: "New Zealand" },
    { id: 159, name: "Nicaragua" },
    { id: 160, name: "Niger" },
    { id: 161, name: "Nigeria" },
    { id: 162, name: "Niue" },
    { id: 163, name: "Norfolk Island" },
    { id: 164, name: "Northern Mariana Islands" },
    { id: 165, name: "Norway" },
    { id: 166, name: "Oman" },
    { id: 167, name: "Pakistan" },
    { id: 168, name: "Palau" },
    { id: 169, name: "Panama" },
    { id: 170, name: "Papua New Guinea" },
    { id: 171, name: "Paraguay" },
    { id: 172, name: "Peru" },
    { id: 173, name: "Philippines" },
    { id: 174, name: "Pitcairn" },
    { id: 175, name: "Poland" },
    { id: 176, name: "Portugal" },
    { id: 177, name: "Puerto Rico" },
    { id: 178, name: "Qatar" },
    { id: 179, name: "Reunion" },
    { id: 180, name: "Romania" },
    { id: 181, name: "Russian Federation" },
    { id: 182, name: "Rwanda" },
    { id: 183, name: "Saint Barthelemy" },
    { id: 184, name: "Saint Helena, Ascension And Tristan Da Cunha" },
    { id: 185, name: "Saint Kitts And Nevis" },
    { id: 186, name: "Saint Lucia" },
    { id: 187, name: "Saint Martin (French Part)" },
    { id: 188, name: "Saint Pierre And Miquelon" },
    { id: 189, name: "Saint Vincent And The Grenadines" },
    { id: 190, name: "Samoa" },
    { id: 191, name: "San Marino" },
    { id: 192, name: "Sao Tome And Principe" },
    { id: 193, name: "Saudi Arabia" },
    { id: 194, name: "Senegal" },
    { id: 195, name: "Serbia" },
    { id: 196, name: "Seychelles" },
    { id: 197, name: "Sierra Leone" },
    { id: 198, name: "Singapore" },
    { id: 199, name: "Sint Maarten (Dutch Part)" },
    { id: 200, name: "Slovakia" },
    { id: 201, name: "Slovenia" },
    { id: 202, name: "Solomon Islands" },
    { id: 203, name: "Somalia" },
    { id: 204, name: "South Africa" },
    { id: 205, name: "South Georgia And The South Sandwich Islands" },
    { id: 206, name: "South Sudan" },
    { id: 207, name: "Spain" },
    { id: 208, name: "Sri Lanka" },
    { id: 209, name: "Suriname" },
    { id: 210, name: "Svalbard And Jan Mayen" },
    { id: 211, name: "Swaziland" },
    { id: 212, name: "Sweden" },
    { id: 213, name: "Switzerland" },
    { id: 214, name: "Syrian Arab Republic" },
    { id: 215, name: "Taiwan" },
    { id: 216, name: "Tajikistan" },
    { id: 217, name: "Tanzania" },
    { id: 218, name: "Thailand" },
    { id: 219, name: "Timor-Leste" },
    { id: 220, name: "Togo" },
    { id: 221, name: "Tokelau" },
    { id: 222, name: "Tonga" },
    { id: 223, name: "Trinidad And Tobago" },
    { id: 224, name: "Tunisia" },
    { id: 225, name: "Turkey" },
    { id: 226, name: "Turkmenistan" },
    { id: 227, name: "Turks And Caicos Islands" },
    { id: 228, name: "Tuvalu" },
    { id: 229, name: "Uganda" },
    { id: 230, name: "Ukraine" },
    { id: 231, name: "United Arab Emirates" },
    { id: 232, name: "United Kingdom" },
    { id: 233, name: "United States" },
    { id: 234, name: "United States Minor Outlying Islands" },
    { id: 235, name: "Uruguay" },
    { id: 236, name: "Uzbekistan" },
    { id: 237, name: "Vanuatu" },
    { id: 238, name: "Vatican City State" },
    { id: 239, name: "Venezuela" },
    { id: 240, name: "Vietnam" },
    { id: 241, name: "British Virgin Islands" },
    { id: 242, name: "Virgin Islands, U.S." },
    { id: 243, name: "Wallis And Futuna" },
    { id: 244, name: "Western Sahara" },
    { id: 245, name: "Yemen" },
    { id: 246, name: "Zambia" },
    { id: 247, name: "Zimbabwe" },
  ]

  const handleChange = e => {
    const { name, value } = e.target
    setPracticeAddress(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="container-fluid">
            <PageTitle title="Profile" />
            {isLoading ? (
              <Spinners setLoading={setLoading} />
            ) : (
              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody>
                      {/* Profile Summary Section */}
                      <div className="d-flex align-items-center mb-4">
                        <div className="me-3">
                          <img
                            src={profileImage ? profileImage : Nouserimage}
                            alt=""
                            className="avatar-md rounded-circle img-thumbnail"
                          />
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="mb-1">{name}</h5>
                          <p className="text-muted mb-0">{email}</p>
                        </div>
                      </div>

                      {/* Alert Messages */}
                      {success && (
                        <Alert color="success" className="mb-4">
                          {success}
                        </Alert>
                      )}

                      {/* Profile Form */}
                      <Form className="form-horizontal" onSubmit={handleSubmit}>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label className="form-label">
                                Username{" "}
                                <i className="mdi mdi-asterisk text-danger"></i>
                              </Label>
                              <Input
                                name="username"
                                className="form-control"
                                placeholder="Enter Username"
                                type="text"
                                defaultValue={username}
                                style={{ height: "38px", fontSize: "14px" }}
                              />
                              {error.username && (
                                <FormFeedback
                                  type="invalid"
                                  style={{ display: "block" }}
                                >
                                  {error.username}
                                </FormFeedback>
                              )}
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label className="form-label">
                                Provider Name{" "}
                                <i className="mdi mdi-asterisk text-danger"></i>
                              </Label>
                              <Input
                                name="Name"
                                className="form-control"
                                placeholder="Enter Provider Name"
                                type="text"
                                value={name}
                                onChange={handleNameChange}
                                style={{ height: "38px", fontSize: "14px" }}
                              />
                              {error.name && (
                                <FormFeedback
                                  type="invalid"
                                  style={{ display: "block" }}
                                >
                                  {error.name}
                                </FormFeedback>
                              )}
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label className="form-label">
                                Practice Name{" "}
                              </Label>
                              <Input
                                name="practicename"
                                className="form-control"
                                placeholder="Enter Practice Name"
                                type="text"
                                value={getPracticeName}
                                onChange={handlePracticeNameChange}
                                style={{ height: "38px", fontSize: "14px" }}
                              />
                              {error.practicename && (
                                <FormFeedback
                                  type="invalid"
                                  style={{ display: "block" }}
                                >
                                  {error.practicename}
                                </FormFeedback>
                              )}
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label className="form-label">
                                Practice Contact First Name
                              </Label>
                              <Input
                                type="text"
                                className="form-control"
                                id="practice_contact_first_name"
                                name="practice_contact_first_name"
                                placeholder="Enter First Name"
                                value={practiceContactFirstName}
                                onChange={handlePracticeContactFirstNameChange}
                              />
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label className="form-label">
                                Practice Contact Last Name
                              </Label>
                              <Input
                                type="text"
                                className="form-control"
                                id="practice_contact_last_name"
                                name="practice_contact_last_name"
                                placeholder="Enter Last Name"
                                value={practiceContactLastName}
                                onChange={handlePracticeContactLastNameChange}
                              />
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label className="form-label">
                                Practice Email
                              </Label>
                              <Input
                                type="email"
                                className="form-control"
                                id="practice_email"
                                name="practice_email"
                                placeholder="Enter Practice Email"
                                value={practiceEmail}
                                onChange={handlePracticeEmailChange}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label className="form-label">
                                Practice Phone Number
                              </Label>
                              <Input
                                type="text"
                                className="form-control"
                                id="practice_phone_number"
                                name="practice_phone_number"
                                placeholder="Enter Practice Phone Number"
                                value={practicePhoneNumber}
                                onChange={handlePracticePhoneNumberChange}
                              />
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label className="form-label">
                                Office Contact Email{" "}
                                <i className="mdi mdi-asterisk text-danger"></i>
                              </Label>
                              <Input
                                name="email"
                                className="form-control"
                                placeholder="Enter Office Contact Email"
                                type="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                style={{ height: "38px", fontSize: "14px" }}
                              />
                              {error.email && (
                                <FormFeedback
                                  type="invalid"
                                  style={{ display: "block" }}
                                >
                                  {error.email}
                                </FormFeedback>
                              )}
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label className="form-label">Phone Number</Label>
                              <Input
                                name="phonenumber"
                                className="form-control"
                                placeholder="Enter Phone Number"
                                type="text"
                                value={phoneNumber}
                                onChange={handlePhoneNumberChange}
                                style={{ height: "38px", fontSize: "14px" }}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label className="form-label">Specialty</Label>
                              <Input
                                type="text"
                                className="form-control"
                                id="specialty"
                                name="specialty"
                                placeholder="Enter Specialty"
                                value={getSpecialty}
                                onChange={handleSpecialtyChange}
                                style={{ height: "38px", fontSize: "14px" }}
                              />
                              {error.specialty && (
                                <FormFeedback
                                  type="invalid"
                                  style={{ display: "block" }}
                                >
                                  {error.specialty[0]}
                                </FormFeedback>
                              )}
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label className="form-label">NPI</Label>
                              <Input
                                type="text"
                                className="form-control"
                                id="qualification"
                                name="qualification"
                                placeholder="Enter NPI"
                                value={getQualification}
                                onChange={handleQualificationChange}
                                style={{ height: "38px", fontSize: "14px" }}
                              />
                              {/* <select
                                name="qualification"
                                className="form-control"
                                value={getQualification}
                                onChange={handleQualificationChange}
                              >
                                <option value="" disabled>Select Qualification</option>
                                <option value="MD">MD</option>
                                <option value="DO">DO</option>
                                <option value="NP">NP</option>
                              </select> */}
                              {error.qualification && (
                                <FormFeedback
                                  type="invalid"
                                  style={{ display: "block" }}
                                >
                                  {error.qualification[0]}
                                </FormFeedback>
                              )}
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label className="form-lable">Fax number</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="faxnumberid"
                                name="faxnumber"
                                placeholder="Enter fax number"
                                value={getFaxNumber}
                                onChange={handleFaxnumberonChange}
                                style={{ height: "38px", fontSize: "14px" }}
                              />
                              {error.faxnumber && (
                                <FormFeedback
                                  type="invalid"
                                  style={{ display: "block" }}
                                >
                                  {error.faxnumber[0]}
                                </FormFeedback>
                              )}
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={12}>
                            <Label className="form-label">
                              Practice Address:
                            </Label>

                            {/* Address Line 1 */}
                            <Input
                              type="text"
                              className="form-control mb-3"
                              placeholder="Address Line 1"
                              name="address_line_1"
                              value={practiceAddress.address_line_1}
                              onChange={handleChange}
                            />

                            {/* Address Line 2 */}
                            <Input
                              type="text"
                              className="form-control mb-3"
                              placeholder="Address Line 2"
                              name="address_line_2"
                              value={practiceAddress.address_line_2}
                              onChange={handleChange}
                            />

                            {/* City, State, ZIP */}
                            <Row>
                              <Col md={3}>
                                <Input
                                  type="text"
                                  className="form-control mb-3"
                                  placeholder="City"
                                  name="city"
                                  value={practiceAddress.city}
                                  onChange={handleChange}
                                />
                              </Col>

                              <Col md={3}>
                                <Input
                                  type="select"
                                  className="form-control mb-3"
                                  name="state"
                                  value={practiceAddress.state}
                                  onChange={handleChange}
                                >
                                  <option value="">Select State</option>
                                  {stateList.map(st => (
                                    <option key={st.id} value={st.name}>
                                      {st.name}
                                    </option>
                                  ))}
                                </Input>
                              </Col>

                              <Col md={3}>
                                <Input
                                  type="text"
                                  className="form-control mb-3"
                                  placeholder="ZIP Code"
                                  name="zip_code"
                                  value={practiceAddress.zip_code}
                                  onChange={handleChange}
                                />
                              </Col>

                              <Col md={3}>
                                <Input
                                  type="select"
                                  className="form-control mb-3"
                                  name="country"
                                  value={practiceAddress.country}
                                  onChange={handleChange}
                                >
                                  <option value="">Select Country</option>
                                  {countryList.map(ct => (
                                    <option key={ct.id} value={ct.name}>
                                      {ct.name}
                                    </option>
                                  ))}
                                </Input>
                              </Col>
                            </Row>

                            {/* Country */}
                          </Col>
                        </Row>

                        <div className="mb-4">
                          <Label className="form-label">Profile Image</Label>
                          <div className="mb-3">
                            <img
                              src={previewImage || profileImage || Nouserimage}
                              alt="Profile"
                              className="img-fluid rounded-circle"
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                          <Input
                            type="file"
                            className="form-control"
                            id="profileImage"
                            onChange={handleImageChange}
                            style={{ height: "38px", fontSize: "14px" }}
                          />
                          {errorimage && (
                            <FormFeedback
                              type="invalid"
                              style={{ display: "block" }}
                            >
                              {errorimage}
                            </FormFeedback>
                          )}
                        </div>

                        <div>
                          <Button
                            type="submit"
                            color="primary"
                            style={{ fontSize: "14px" }}
                          >
                            Update Profile
                          </Button>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(UserProfile)
